import { LATITUDE_REGEX, LONGITUDE_REGEX } from "@/constants";
import { z } from "@/zod";

export const coordinates = z.object({
  latitude: z.coerce
    .number()
    .min(-90)
    .max(90)
    .optional()
    .refine((value) => (value ? LATITUDE_REGEX.test(value.toString()) : true)),
  longitude: z.coerce
    .number()
    .min(-180)
    .max(180)
    .optional()
    .refine((value) => (value ? LONGITUDE_REGEX.test(value.toString()) : true)),
});

export const nullableCoordinates = coordinates.extend({
  latitude: coordinates.shape.latitude.nullable(),
  longitude: coordinates.shape.longitude.nullable(),
});
